function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M233.8 283.4h-28.5V177.1h-45V71.4c0-32.7 26.6-59.2 59.3-59.3h14.2v271.3zM205.3 44.1c-10.2 5.3-16.5 15.8-16.5 27.3v77.3h16.5V44.1zM122 28.3v68.8c0 .7 0 1.3-.1 2h-10.1V28.3H97.3v70.8H87.1V28.3H72.6v70.8H62.5c0-.7-.1-1.3-.1-2V28.3H47.9v68.8C47.8 116 60 132.6 78 138.2v145.3h28.3V138.2c18-5.6 30.2-22.3 30.1-41.1V28.3H122z"
})));